import { render, staticRenderFns } from "./WidgetTomanConverter.vue?vue&type=template&id=42af67c4&"
import script from "./WidgetTomanConverter.vue?vue&type=script&lang=ts&"
export * from "./WidgetTomanConverter.vue?vue&type=script&lang=ts&"
import style0 from "./WidgetTomanConverter.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QSeparator});
